export {Radio as Page};

import messages from "../../messages/messages.js";
import {Helmet} from "react-helmet-async";
import {RadioComponent} from "../../components/RadioComponent.jsx";
import {Bars3Icon} from "@heroicons/react/24/solid";

function Radio() {
    const year = new Date().getFullYear();
    const mainUrl = "https://www." + messages["DOMAIN"];

    return (
        <>
            <nav
                className="fixed w-full top-0 z-40 bg-background/60 backdrop-blur supports-[backdrop-filter]:bg-background/50 px-4">
                <div className="flex items-center justify-between h-14 ">
                    <img alt="website logo" height={20} width={160} src={"/img/" + messages.LOGO}/>
                </div>
            </nav>

            <section className="pt-24 pb-16 px-4">
                <Helmet>
                    <title>{messages["SITE.NAME"]} Radio</title>
                </Helmet>
                <div className="max-w-5xl mx-auto">
                    <RadioComponent/>
                </div>
            </section>
            <footer className="border-t px-4 py-6 text-sm text-gray-400">
                <div className="container flex flex-col items-start">
                    <span>Powered by</span>
                    <a href={mainUrl} target="_blank">
                        <img className="mx-auto my-4 w-40"
                             alt={`${messages["SITE.NAME"]} website logo`}
                             src={"/img/" + messages["LOGO"]}/>
                    </a>
                    © Copyright {messages["SITE.NAME"]} {year}.
                </div>
            </footer>
        </>
    );
}